import Image from 'next/image';
import { ImageWithBlockSliceData } from '@adapters/prismic/types/slices';
import Link from 'next/link';
import MarkdownCopy from '../MarkdownCopy';
import styles from './ImageWithBlock.module.scss';

const ImageWithBlock = ({ id, image, copy, link }: ImageWithBlockSliceData) =>
  image ? (
    <div id={id} className={styles.imageWithBlock}>
      <div className={styles.imageContainer}>
        {link?.url ? (
          <Link href={link.url}>
            <Image
              src={image.url}
              alt={image.alt || ''}
              quality={65}
              fill
              sizes="(min-width: 480px) 152px, 480px"
            />
          </Link>
        ) : (
          <Image
            src={image.url}
            alt={image.alt || ''}
            quality={65}
            fill
            sizes="(min-width: 480px) 152px, 480px"
          />
        )}
      </div>
      <div className={styles.blockContainer}>
        <MarkdownCopy text={copy?.[0].text ?? ''} className={styles.noMargin} />
      </div>
    </div>
  ) : null;

export default ImageWithBlock;
